var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row d-flex"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"p-3 bg-white shadow-sm rounded-lg"},[_c('auth')],1)]),_c('div',{staticClass:"col-md-6 flex-fill"},[_c('password')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }